/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Fact_FloorInputs */

const cs_public_site_fact_floor = /** @type {(inputs: Public_Site_Fact_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podlaží`)
};

const en_public_site_fact_floor = /** @type {(inputs: Public_Site_Fact_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor`)
};

/**
* | output |
* | --- |
* | "Floor" |
*
* @param {Public_Site_Fact_FloorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_fact_floor = /** @type {((inputs?: Public_Site_Fact_FloorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Fact_FloorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_fact_floor(inputs)
	return cs_public_site_fact_floor(inputs)
});